import $axios from "../http/accessor";
import { auth } from "../endpoints/auth.endpoints";

const AuthService = {
  login: (data: FormData) => {
    return $axios.post(auth.login, data);
  },

  register: (data: FormData) => {
    return $axios.post(auth.register, data);
  },

  logout: () => {
    return $axios.post(auth.logout);
  },

  sendOtp: (data: FormData) => {
    return $axios.post(auth.otp, data);
  },

  resendOtp: (data: FormData) => {
    return $axios.post(auth.resend_otp, data);
  },

  forgetPassword: (data: FormData) => {
    return $axios.post(auth.forget_password, data);
  },

  confirmForgetPassword: (data: FormData) => {
    return $axios.post(auth.confrim_forget_password, data);
  },

  getStoreInfo: () => {
    return $axios.get(auth.get_store_info);
  },
  updateStoreInfo: (data: FormData) => {
    return $axios.put(auth.update_store_info, data);
  },
};

export default AuthService;
